<template>
  <div v-if="propertyStore?.reviewsInfo?.ratings_total" class="property-reviews__top">
    <div v-if="propertyStore?.reviewsInfo.rating" class="reviews-rating">
      <div :class="['reviews-rating__value review-value-block', ratingClass(parseInt(propertyStore.reviewsInfo.rating))]">
        {{parseInt(propertyStore.reviewsInfo.rating)}}
      </div>
      <div class="reviews-rating__label text-body-2 fw-semi-bold">
        <span v-if="parseFloat(round(parseInt(propertyStore.reviewsInfo.rating))) >= 9">Excellent</span>
        <span v-else-if="parseFloat(round(parseInt(propertyStore.reviewsInfo.rating))) >= 7">Very Good</span>
        <span v-else-if="parseFloat(round(parseInt(propertyStore.reviewsInfo.rating))) >= 6">Good</span>
        <span v-else-if="parseFloat(round(parseInt(propertyStore.reviewsInfo.rating))) >= 4">Fair</span>
        <span v-else-if="parseFloat(round(parseInt(propertyStore.reviewsInfo.rating))) > 0">Poor</span>
        <span v-else>{{$t('No reviews')}}</span>
      </div>
      <div class="reviews-rating__total text-caption color-dark-grey">
        {{propertyStore.reviewsInfo.ratings_total}} {{$t('reviews')}}
      </div>
    </div>
    <div class="reviews-stats">
      <div
        v-for="subrating in propertyStore.reviewsInfo?.tripadvisor_info?.subratings"
        :key="subrating.localized_name"
        class="reviews-stats__item"
      >
        <div class="reviews-stats__item-label">
          {{$t(subrating.localized_name)}}
        </div>
        <div class="reviews-stats__item-detail">
          <div class="reviews-stats__item-progressbar">
            <div class="value" :style="`width: ${(subrating.value / 10) * 100}%`"/>
          </div>
          <div class="reviews-stats__item-value">{{ subrating.value.toFixed(1) }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-review-wrapper" v-else>
    <span class="text-body-1 fw-medium color-dark-grey">{{$t('Sorry, we do not have any reviews yet')}}</span>
  </div>
</template>
<script setup lang="ts">
import {usePropertyStore} from '~/store/property'

const propertyStore = usePropertyStore()

function round(rating:number) {
  return ((rating ^ 0) === rating) ? (+rating).toFixed() : (+rating).toFixed(1)
}

const ratingClass = (rating:number) => {
  if (rating) {
    if (rating >= 9) {
      return 'excellent'
    } else if (rating >= 7) {
      return 'very-good'
    } else if (rating >=6) {
      return 'good'
    } else if (rating >= 4) {
      return 'fair'
    } else if (rating > 0) {
      return 'poor'
    }
  }
  return 'no-reviews'
}
</script>
<style lang="scss" scoped>
.no-review-wrapper {
  margin-top: 5px;

  @media screen and (max-width: 430px) {
    margin-top: 0;
  }
}
.property-reviews__top {
  display: flex;
  padding-bottom: 24px;
  gap: 24px;
  .reviews-rating {
    padding: 12px 16px;
    width: 166px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border: 3px solid var(--grey-border);
    border-radius: 16px;
  }
  .reviews-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    width: 100%;
    .reviews-stats__item {
      width: calc(50% - 12px);
      .reviews-stats__item-label {
        font-size: 14px;
      }
      .reviews-stats__item-detail {
        display: flex;
        align-items: center;
        gap: 8px;
        .reviews-stats__item-progressbar {
          $border-radius: 4px;
          flex: 1;
          height: 8px;
          background-color: var(--blue-highlight);
          display: flex;
          border-radius: $border-radius;

          .value {
            border-top-left-radius: $border-radius;
            border-bottom-left-radius: $border-radius;
            background-color: var(--blue);
          }
        }
        .reviews-stats__item-value {
          font-size: 14px;
          font-weight: 500;
          min-width: 28px;
          text-align: right;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .property-reviews__top {
    flex-direction: column;
    .reviews-rating {
      width: 100%;
      flex-direction: row;
    }
  }
}
.review-value-block {
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--black);
  color: var(--white);
  font-size: 16px;
  font-weight: 500;

  &.excellent {
    background: var(--green);
  }

  &.very-good, &.good {
    background: var(--light-green);
  }

  &.poor, &.fair {
    background: var(--black);
  }
}
</style>
